import React, { Component } from 'react';
import Header from '../partials/Header';
import Left from '../partials/Left';
import Footer from '../partials/Footer';
import Rqulinks from '../partials/Rqulinks';
import Qlinks from '../partials/Qlinks';
import Contbtm from '../partials/Contbtm';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';
import * as helper from '../config/Config';
import MyJourney from '../learning_records/MyJourney';
import MyJourneyDemo from '../learning_records/MyJourneyDemo';
import MyDiary from '../learning_records/MyDiary';
import MyPerformance from '../learning_records/my_performance/MyPerformance';
import MyPerformanceDemo from '../learning_records/my_performance/MyPerformanceDemo';
import AssessementComp from '../learning_records/my_performance/AssessementComp';
import Recap from '../learning_records/recap/Recap';
import LoginHistory from '../learning_records/LoginHistory';
import Componetlist from '../lr_dlr_components/Componetlist';
import Anouncement from '../lr_dlr_components/Anouncement';
import MyProfile from '../my_profile/MyProfile';
import Courseware from '../learning_resources/Courseware';
import Mylibrary from '../learning_resources/library/Mylibrary';
import IseekFeedback from '../personal_interactions/iseek/IseekFeedback';
import MyObserver from '../personal_interactions/observer/MyObserver';
import TechSupport from '../personal_interactions/technical_support/TechSupport';
import TelecallRequest from '../personal_interactions/telecall_request/TelecallRequest';
import PersonalMessages from '../personal_interactions/messages/PersonalMessages';
import Ecoach from '../personal_interactions/ecoach/Ecoach';
import ChatRequest from '../personal_interactions/ecoach_request/ChatRequest';
import OpinionPoll from '../group_interactions/OpinionPoll';
import Collaborate from '../group_interactions/Collaborate';
import Challenge from '../challenge_score_card/Challenge';
import PracticeNokia from '../practice/PracticeNokia';
import XRecap from '../xrecap/XRecap';
import DatewiseComp from '../practice/DatewiseComp';
import PracticewiseComp from '../practice/PracticewiseComp';
import Notes from '../lr_dlr_components/Notes';
import EcProfile from '../lr_dlr_components/EcProfile';
import Radio from '../radio/Radio';
import CareerLauncher from '../lr_dlr_components/Careerlauncherrc';
import Geolocation from "react-geolocation";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getNewPost } from '../actions/newPostAction';

const $ = window.$;
const jQuery = window.jQuery;
class Main extends Component {
	constructor(props) {
		super(props);
		this.passLrid = this.passLrid.bind(this);
		this.getPostions = this.getPostions.bind(this);
		this.state = {
			contentPanel: <Componetlist switchPanel={this.passLrid} lr_id="0" dlr_id="0" />,
			leftPanel: "big",
			defaultLrID: (Common.getUserData('defaultLRID', true) != undefined) ? Common.getUserData('defaultLRID', true) : 0,
			page_id: '',
			fnHideCorporateIDs: Common.getUserData('fnHideCorporateIDs', true),
			changed_status: '',
			statusBuddyChat: (Common.getUserData("statusBuddyChat", true) != false) ? Common.getUserData("statusBuddyChat", true) : 0,
			cprofile: ""
		};
	}
	getPostions(obj) {
		let coords = obj.coords;
		fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + coords.latitude + ',' + coords.longitude + '&sensor=true', {
			method: 'GET'
		}).then((response) => response.json()).then((responseJson) => {
			if (responseJson.status == 'OK') {
				if (Common.isset(responseJson.results[0])) {
					localStorage.setItem("geo_location" + helper.app_name, responseJson.results[0].formatted_address);
				}
			}
		});
	}
	componentDidMount() {
		document.body.id = "bodyid";
		document.body.className = "";
		setTimeout(() => {
			jQuery(document).on("click", ":not(.cont-btm, .top-links, #qlinks, #qlinks1,select#cmbStatus,#statusforms *)", function (e) {
				jQuery('.cont-btm ul li').each(function ($) {
					jQuery(this).find(".f-popup").slideUp();
					jQuery(this).find("a").removeClass('act-tab');
				});
				jQuery('aside').each(function ($) {
					jQuery(this).removeClass('opened');
				});
				e.stopPropagation();
			});
			jQuery('select#cmbStatus,#statusforms,input#jquerysubject,textarea#jqueryquery,input#jqueryfile').click(function (event) {
				event.stopPropagation();
			})
			jQuery('.cont-btm, .top-links, #qlinks, #qlinks1').click(function (event) {
				if (jQuery(event.target).hasClass('cntbtm')) {
					if (jQuery(event.target).parent().find(".f-popup").css('display') == 'none') {
						jQuery('.cont-btm ul li').each(function ($) {
							jQuery(this).find(".f-popup").slideUp();
							jQuery(this).find("a").removeClass('act-tab');
						});
						var currentPopUpHeight = jQuery(event.target).parent().find(".f-popup").height();
						// jQuery(event.target).parent().find( ".f-popup" ).css({"height":+currentPopUpHeight+'px'});
						jQuery(event.target).parent().find(".f-popup").slideToggle();
						jQuery(event.target).addClass('act-tab');
					} else {
						jQuery(event.target).parent().find(".f-popup").slideUp();
						jQuery(event.target).removeClass('act-tab');
					}
					event.stopPropagation();
				} else if (jQuery(jQuery(event.target).parent()).hasClass('slide-out')) {
					if (jQuery(event.target).parent().hasClass('opened')) {
						jQuery(event.target).parent().removeClass('opened');
					} else {
						jQuery('aside').each(function () {
							jQuery(this).removeClass('opened');
						});
						jQuery(event.target).parent().addClass('opened');
					}
					event.stopPropagation();
				}
			});
		}, 500)

		
		
		//new post call every 30 mins 
		// setTimeout(() => {setInterval(() => {this.props.getNewPost();},1800000)},1800000);

		//new post call every 6hr
		setTimeout(() => {setInterval(() => {this.props.getNewPost();},21600000)},21600000);
		
		


	}
	defaultComponents() {
		this.setState({
			contentPanel: <Componetlist switchPanel={this.passLrid} key={`default_0`} lr_id="0" dlr_id="0" />,
			leftPanel: "big"
		});
		// Common.showLargeLeftMenu();
	}
	// onChangeProf(val){
	//   this.refs.headerUpdate.updatePhoto(val);
	// }
	passLrid(type, lr_id = "", dlr_id = "") {
		this.setRouteContentPanel(type, lr_id, dlr_id);
	}
	headerMenu(type) {
		this.setRouteContentPanel(type);
	}
	getSentmessage(new_msg) {
		// this.setState({message : new_msg});
		// this.refs.headerUpdate.updateMessage(new_msg);
		this.refs.RqUpdate.updateMessage(new_msg);
		this.refs.BotUpdate.updateMessage(new_msg);
		//this.props.inboxUnread(new_msg);
	}
	// getopinion(count_poll){
	//   this.refs.BotUpdate.updateOpinion(count_poll);
	// }
	setRouteContentPanel(type, lr_id = "", dlr_id = "") {
		jQuery('.slide-out').removeClass('opened');
		if (type == "Challenge" || type == "PracticeNokia" || type == "practice_datewise" || type == 'practice_score') {
			jQuery(".leftposstatic").css('display', 'none');
		} else {
			jQuery(".leftposstatic").css('display', 'block');
		}
		// alert(type);
		let panel = this.state.contentPanel;
		let leftPanel = this.state.leftPanel;
		
		switch (type) {
			
			case 'componet_list':
				panel = <Componetlist key={Date.now()} switchPanel={this.passLrid} lr_id={lr_id} dlr_id={dlr_id} />;
				leftPanel = 'big';
				break;
			case 'my_journey':
				panel = <MyJourney switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'my_journey_demo':
				panel = <MyJourneyDemo switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'seek_notes':
				panel = <Notes type="seek_notes" />;
				leftPanel = 'small';
				break;
			case 'sharek_notes':
				panel = <Notes type="sharek_notes" />;
				leftPanel = 'small';
				break;
			case 'share_requests':
				panel = <Notes type="share_requests" />;
				leftPanel = 'small';
				break;
			case 'all_notes':
				panel = <Notes type="all_notes" />;
				leftPanel = 'small';
				break;
			case 'my_diary':
				panel = <MyDiary switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'my_performance':
				panel = <MyPerformance switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'my_performance_demo':
				panel = <MyPerformanceDemo switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'recap':
				panel = <Recap switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'my_profile':
				panel = <MyProfile />;
				leftPanel = 'small';
				break;
			case 'Observers':
				panel = <MyObserver />;
				leftPanel = 'small';
				break;
			case 'login_history':
				panel = <LoginHistory />;
				leftPanel = 'small';
				break;
			case 'Seekfeedback':
				panel = <IseekFeedback />;
				leftPanel = 'small';
				break;
			case 'ecoach':
				panel = <Ecoach />;
				leftPanel = 'small';
				break;
			case 'chat_request':
				panel = <ChatRequest />;
				leftPanel = 'small';
				break;
			case 'courseware':
				panel = <Courseware />;
				leftPanel = 'small';
				break;
			case 'library':
				panel = <Mylibrary />;
				leftPanel = 'small';
				break;
			case 'Techsupport':
				panel = <TechSupport />;
				leftPanel = 'small';
				break;
			case 'Telecall':
				panel = <TelecallRequest />;
				leftPanel = 'small';
				break;
			case 'messages':
				panel = <PersonalMessages />;
				leftPanel = 'small';
				break;
			case 'opinion_poll':
				panel = <OpinionPoll switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'collaborate':
				panel = <Collaborate switchPanel={this.passLrid} />;
				leftPanel = 'small';
				break;
			case 'radio':
				panel = <Radio />;
				leftPanel = 'small';
				break;
			case 'anouncement':
				panel = <Anouncement lr_id={lr_id} dlr_id={dlr_id} />;
				leftPanel = 'big';
				break;
			case 'Challenge':
				panel = <Challenge />;
				leftPanel = 'small';
				break;
			case 'PracticeNokia':
				panel = <PracticeNokia switchPanel={e => this.setRouteContentPanel(e)} />;
				leftPanel = 'small';
				break;
			case 'Xrecap':
				panel = <XRecap />;
				leftPanel = 'small';
				break;
			case 'practice_datewise':
				panel = <DatewiseComp switchPanel={e => this.setRouteContentPanel(e)} />;
				leftPanel = 'small';
				break;
			case 'practice_score':
				panel = <PracticewiseComp switchPanel={e => this.setRouteContentPanel(e)} />;
				leftPanel = 'small';
				break;
			case 'ec_profile':
				panel = <EcProfile />;
				leftPanel = 'small';
				break;
			case 'assessement_status':
				panel = <AssessementComp />;
				leftPanel = 'small';
				break;
		}
		this.setState({
			contentPanel: panel,
			leftPanel: leftPanel,
			cprofile: type
		});
		setTimeout(() => {
			if (leftPanel == 'small') {
				Common.showSmallLeftMenu();
				Common.contentResizeLoad();
			} else {
				Common.showLargeLeftMenu();
				Common.contentResizeLoad();
			}
		}, 500);
	}
	isSessionExist() {
		if (!User.isLoggedIn()) {
			this.props.router.push("login");
		}
	}
	getsetStatus = (val) => {
		this.setState({ statusBuddyChat: val })
		// if(val !== ''){
		// 	this.refs.RqUpdate.changeStatus(val);
		// 	this.refs.BotUpdate.changeStatus(val);
		// }
	}
	clback() {
		this.setState({ cprofile: "" });
	}
	render() {
		this.isSessionExist();
		let practiceCorner = Common.getUserData("practiceCorner", true);
		let practiceCornerMini = Common.getUserData("practiceCornerMini", true);
		let challenge_score = Common.getUserData('challenge_score', true);
		let xrecap_id = Common.getUserData('xrecap_id', true);
		let is_careerlauncher = Common.getUserData('is_careerlauncher', true);
		let practice_nokia = '';
		if (practiceCorner != false) {
			practice_nokia = <a className={(xrecap_id != '' || xrecap_id != 0) ? "getpractice practice_minii" : "getpractice practice_minii"} href="javascript:void(0);" onClick={e => this.setRouteContentPanel('PracticeNokia')} title='Practice Corner Mini'></a>
		} else if (practiceCornerMini != false) {
			practice_nokia = <a className={(xrecap_id != '' || xrecap_id != 0) ? "getpractice practice_minii" : "getpractice practice_minii"} href="javascript:void(0);" onClick={e => this.setRouteContentPanel('PracticeNokia')} title='Practice Corner Mini'></a>
		} else { }
		return (<div id="361_wall_container">
			<Geolocation onSuccess={this.getPostions} />
			<div id="window_trans"></div>
			<div id="page">
				{!is_careerlauncher && <div className="row">
					{this.state.fnHideCorporateIDs === false &&
						<div>
							<Rqulinks ref="RqUpdate" setStatusUpdate={this.getsetStatus} statusBuddyChat={this.state.statusBuddyChat} switchPanel={e => this.setRouteContentPanel(e)} />

							{practice_nokia}
							{(xrecap_id != '' || xrecap_id != 0) ? <a style={{ zIndex: '999' }} className="getxpractice practiceback" href="javascript:void(0);" onClick={e => this.setRouteContentPanel('Xrecap')} title="Recaps"></a> : ''}

							{(challenge_score > 0) ? <a className="getchallenge challengeback" href="javascript:void(0);" onClick={e => this.setRouteContentPanel('Challenge')} title="Challenge Score Card"></a> : ''}
						</div>
					}
					<Qlinks switchPanel={e => this.setRouteContentPanel(e)} />
					<div className="top-bg"></div>
					<Header switchPanel={() => this.defaultComponents()} menuClick={(e) => this.headerMenu(e)} />
					<section className="maincontent fixed_cont" id="maincontent">
						<Left leftMenuType={this.state.leftPanel} onClick={this.passLrid} />
						{this.state.contentPanel}
					</section>
					<Contbtm ref="BotUpdate" setStatusUpdate={this.getsetStatus} statusBuddyChat={this.state.statusBuddyChat} switchPanel={e => this.setRouteContentPanel(e)} />
					<Footer />
				</div>
				}

				{is_careerlauncher && <div className="row">
					<Qlinks switchPanel={e => this.setRouteContentPanel(e)} />
					<div className="top-bg"></div>
					<Header switchPanel={e => this.defaultComponents()} menuClick={e => this.headerMenu(e)} />
					{this.state.cprofile != "my_profile" && <section className="maincontent fixed_cont" id="maincontent">
						<CareerLauncher />
					</section>}
					{this.state.cprofile == "my_profile" &&
						<section className="maincontent fixed_cont carrlan" id="maincontent">
							<div className="completedcomp cldiv">
								<img src={process.env.PUBLIC_URL + '/images/smctick.png'} /> &nbsp;
								<a href="javascript:void(0);" onClick={e => this.clback()}>&nbsp; Click here to Go Back</a>
							</div>
							<MyProfile />
						</section>}
					<Footer />
				</div>
				}
			</div>
		</div>);
	}
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators({ getNewPost }, dispatch);
  }
  
  export default connect(null, mapDispatchToProps)(Main);
  


// WEBPACK FOOTER //
// ./src/layouts/Main.js